"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

/**
 * Adds a key/value pair to the storage object.
 *
 * @param  {String} key the storage item key
 * @param  {Object} val the storage item value
 */
var setItem = function setItem(key, val) {
  if (window.sessionStorage) {
    window.sessionStorage.setItem(key, val);
  }
};

/**
 * Retrieves the value for a given key.
 *
 * @param  {String} key the storage item key
 * @returns {Object} the value for the given key
 */
var getItem = function getItem(key) {
  if (window.sessionStorage) {
    return window.sessionStorage.getItem(key);
  }
  return null;
};

/**
 * Removes a key/value pair from the storage object.
 *
 * @param  {String} key the storage item key
 */
var removeItem = function removeItem(key) {
  if (window.sessionStorage) {
    window.sessionStorage.removeItem(key);
  }
};

exports.default = {
  setItem: setItem,
  getItem: getItem,
  removeItem: removeItem
};